import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import styled from "styled-components";
import Home from "../../pages/home";
import About from "../../pages/about";
import Works from "../../pages/works";
import Service from "../../pages/service";
import Contact from "../../pages/contact";
import WorkDetail from "pages/works/detail";
import ContactResult from "pages/contact/result";
import ContactBanner from "components/ContactBanner";

const AppContent = () => {
  const location = useLocation();
  const isContactPage = location.pathname.includes('/contact');

  return (
    <ContentContainer>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/works" element={<Works />} />
        <Route path="/works/:urlPath" element={<WorkDetail />} />
        <Route path="/service" element={<Service />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/contact/form" element={<Contact />} />
        <Route path="/contact/result" element={<ContactResult />} />
        {/* 이전 경로 리다이렉트 */}
        <Route path="/work" element={<Navigate to="/works" replace />} />
        <Route path="/work/:id" element={<Navigate to="/works/:id" replace />} />
        <Route path="/voucher" element={<Navigate to="/service?tab=voucher" replace />} />
        {/* 마케팅 카테고리 리다이렉트 */}
        <Route path="/performancemarketing" element={<Navigate to="/works?filter=GrowthMarketing" replace />} />
        <Route path="/ugcmarketing" element={<Navigate to="/works?filter=UGCMarketing" replace />} />
        <Route path="/contents" element={<Navigate to="/works?filter=Contents" replace />} />
        <Route path="/growthconsulting" element={<Navigate to="/about" replace />} />
        {/* 존재하지 않는 페이지는 홈으로 리다이렉트 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isContactPage && <ContactBanner />}
    </ContentContainer>
  );
};

const ContentContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: visible; /* 오버플로우 허용 */
`;

export default AppContent;
